import appConstants from "../../../../../appConstants";

const constants = {
  ROUTE_MAPPING_TOOL_COLOR_PALETTE: [
    "#1B43B1",
    "#1262BA",
    "#20609B",
    "#364296",
    "#263FE8",
    "#A9385E",
    "#CE2A5D",
    "#861538",
    "#9DA824",
    "#8C8B33",
    "#16AFB6",
    "#298EA3",
    "#3A8492",
    "#C8B504",
    "#C1830B",
    "#BE550E",
    "#B55D17",
    "#D82F16",
    "#DA4314",
    "#B4231B",
    "#8F16B6",
    "#5B0AC2",
    "#563B91",
    "#764686",
    "#9848AE",
    "#71269C",
    "#13B946",
    "#47903C",
    "#3D7033",
    "#3E837B",
  ],
  ROUTE_MAPPING_FILTER_OPTIONS: [
    {
      label: "P & D",
      value: "all",
    },
    {
      label: "Pickups",
      value: appConstants.STOP_TYPE.Pickup,
    },
    {
      label: "Deliveries",
      value: appConstants.STOP_TYPE.Delivery,
    },
  ],
};

export default constants;
